import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts'
import { useSettingsStore } from '@/state/useSettingsStore'

interface Props {
  data: Array<{ t: string; v: number }>
  height?: number
}

export function CsatTrend({ data, height = 180 }: Props) {
  const locale = useSettingsStore((s) => s.locale)
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
        <CartesianGrid stroke="var(--border)" strokeDasharray="2 4" vertical={false} />
        <XAxis
          dataKey="t"
          axisLine={false}
          tickLine={false}
          stroke="var(--ink-subtle)"
          fontSize={11}
          tickFormatter={(iso) =>
            new Date(iso).toLocaleDateString(locale === 'cs' ? 'cs-CZ' : 'en-GB', {
              day: 'numeric',
              month: 'short',
            })
          }
          minTickGap={28}
        />
        <YAxis domain={[3.8, 5]} hide />
        <Tooltip
          contentStyle={{
            background: 'var(--surface-1)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            fontSize: 12,
            color: 'var(--ink)',
          }}
          formatter={(v) => [(v as number).toFixed(2), 'CSAT']}
        />
        <Line
          type="monotone"
          dataKey="v"
          stroke="var(--brand-accent)"
          strokeWidth={2.2}
          dot={false}
          activeDot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
